__turbopack_context__.v({
  "backdrop-in": "PortalShareButton-module__p4TnEq__backdrop-in",
  "channelIcon": "PortalShareButton-module__p4TnEq__channelIcon",
  "channels": "PortalShareButton-module__p4TnEq__channels",
  "close": "PortalShareButton-module__p4TnEq__close",
  "content": "PortalShareButton-module__p4TnEq__content",
  "copyField": "PortalShareButton-module__p4TnEq__copyField",
  "copySection": "PortalShareButton-module__p4TnEq__copySection",
  "dialog": "PortalShareButton-module__p4TnEq__dialog",
  "dialog-in": "PortalShareButton-module__p4TnEq__dialog-in",
  "email": "PortalShareButton-module__p4TnEq__email",
  "facebook": "PortalShareButton-module__p4TnEq__facebook",
  "feedback": "PortalShareButton-module__p4TnEq__feedback",
  "header": "PortalShareButton-module__p4TnEq__header",
  "linkedin": "PortalShareButton-module__p4TnEq__linkedin",
  "trigger": "PortalShareButton-module__p4TnEq__trigger",
  "triggerIcon": "PortalShareButton-module__p4TnEq__triggerIcon",
  "whatsapp": "PortalShareButton-module__p4TnEq__whatsapp",
  "x": "PortalShareButton-module__p4TnEq__x",
});
